export default [
  {
    title: 'Члены СНТ',
    subtitle: 'Список членов и их платежи',
    key: 'members',
    class: 'blue lighten-2 white--text',
    icon: 'people',
    link: '/manager/clients'
  },
  {
    title: 'Целевые бюджеты',
    subtitle: 'Создание и редактирование',
    key: 'budgets',
    class: 'v-icon green white--text',
    content:'₽',
    icon: '',
    link: '/manager/budgets'
  },
  {
    title: 'Управление',
    subtitle: 'Цена за сотку, реквизиты',
    key: 'management',
    class: 'amber darken-2 white--text',
    icon: 'control_camera',
    link: '/manager/management'
  },
  {
    title: 'Рассылка',
    subtitle: 'Групповая и индивидуальная e-mail рассылка',
    key: 'mailing',
    class: 'amber darken-2 white--text disabled',
    icon: 'mail',
    link: '/manager/mailing'
  }
]
